import { getUserTrackerPrices } from '../../api/subscriptions.api'
import { activeTestFleet } from '../../shared/testFleet'

const state = {
  subscriptions: [],
  selectedOptions: [],
}

const getters = {
  getSubscriptions(state) {
    return state.subscriptions
  },
  getSubscriptionBySerial: (state) => (serial) => {
    if (!serial) return null
    return state.subscriptions.find((sub) => sub.serial === serial) || null
  },
  getSelectedOptions(state) {
    return state.selectedOptions
  },
}

const actions = {
  async fetchSubscriptions({ commit }) {
    try {
      const response = await getUserTrackerPrices()
      commit('SET_SUBSCRIPTIONS', activeTestFleet()?.subscriptions ?? response.data)
    } catch (error) {
      console.error('fetchSubscriptions', error)
    }
  },
  async addOptionToSelectedOptions({ commit }, elementToAdd) {
    commit('ADD_SUBSCRIPTION_OPTION', elementToAdd)
  },
  async removeOptionToSelectedOptions({ commit }, elementToRemove) {
    commit('REMOVE_SUBSCRIPTION_OPTION', elementToRemove)
  },
}

const mutations = {
  SET_SUBSCRIPTIONS(state, data) {
    state.subscriptions = data
  },
  REMOVE_SUBSCRIPTIONS(state) {
    state.subscriptions = []
  },
  ADD_SUBSCRIPTION_OPTION(state, elementToAdd) {
    if (!state.selectedOptions.includes(elementToAdd)) {
      state.selectedOptions.push(elementToAdd)
    }
  },
  REMOVE_SUBSCRIPTION_OPTION(state, elementToRemove) {
    let idx = state.selectedOptions.indexOf(elementToRemove)
    if (idx > -1) {
      state.selectedOptions.splice(idx, 1)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
